module.exports = __webpack_public_path__ + "img/603869.98c4e408.jpg";